import React from 'react';
import './App.css'; 
import { useLocation, Route , Routes as Switch } from 'react-router-dom'; 
//import SlideRoutes from 'react-slide-routes';
import ContextData from './context/Data/ContextData';
import ReducerData from './context/Data/ReducerData';
import StateData from './context/Data/StateData';
  
//import Main from './routes/Main/Main';  
import './routes/Main/main.css';  
import Question from './routes/Question/Question';     
import Results from './routes/Results/Results';    

const getFrameBackground = (frameSuffix) => {
    if (!window.matchMedia("(min-width: 100vh)").matches) {
        return "url(assets/img/fon.jpg)";
    }

    if (frameSuffix === "main") {
        return "url(assets/img/fonPCmain2.jpg)";
    }

    return "url(assets/img/fonPC2.jpg)";
}

export const shuffle = (array) => {
  array.sort(() => Math.random() - 0.5);
}


function App() {
    const [stateData, dispatchData] = React.useReducer(ReducerData, StateData)
    const location = useLocation();    
 
 

 
    React.useEffect(() => { 
        //window.scrollTo(0, 0);   
    });
 

    if(!stateData.contextQuestionsForUser) {
        let arr = [0,1,2,3,4,5,6,7,8,9];
        shuffle(arr); 
        stateData.contextSecondSession = [arr[0],arr[1],arr[2],arr[3],arr[4]];
        stateData.contextQuestionsForUser = [arr[5],arr[6],arr[7],arr[8],arr[9]]; 
    }

    const frameSuffix = location.pathname==='/' ? 'first-question' : location.pathname.substring(1);
    const backgroundImage = getFrameBackground(frameSuffix);
  
    return ( 
        <div className={"frame frame--"+frameSuffix} style={{ backgroundImage }}>
            <div className="logo">
                <img className="logo__left" src="assets/img/logo1.svg" alt="logo" />
                <svg className="logo__x" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="0.830073" y1="0.90479" x2="17.9178" y2="17.9926" stroke="white" strokeWidth="1.8589"/>
                    <line y1="-0.929452" x2="24.1658" y2="-0.929452" transform="matrix(-0.707107 0.707107 0.707107 0.707107 18.7617 1.56201)" stroke="white" strokeWidth="1.8589"/>
                </svg>
                <img className="logo__right" src="assets/img/logo2.svg" alt="logo" />
            </div>  
            <div className="frame__content">                   
                <ContextData.Provider value={{stateData, dispatchData}}>                        
                    <Switch>    
                        <Route path="/" element={<Question/>} />         
                        {stateData.contextNav.map((el, i) => { 
                            return (
                                <Route key={'routeq1'+i} path={"/"+el} element={<Question/>} /> 
                            ); 
                        })}  
                        <Route path="/results" element={<Results/>} />      
                    </Switch>    
                </ContextData.Provider>  
            </div> 
 
        </div>
    );
}

export default App;